import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React from 'react';
import classNames from 'classnames';
import { getThemeClassNames, IconWrapper } from '@cognite/cogs-utils';
import '../../tokens/color-tokens/index.js';
import '../../tokens/elevation-tokens/index.js';
import { Body } from '../../tokens/typography/typography.js';
import '@cognite/cogs-icons';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.object.to-string.js';
import { Tooltip } from '../tooltip/tooltip.js';
import 'core-js/modules/es.array.map.js';
import '@mui/base/Button';
import { VisuallyHidden } from '../_technical/visually-hidden/visually-hidden.js';
import { getCounterString } from './utils.js';

/**
 * Counter chips communicate the number of items in a collection or category.
 */
var CounterChip = /*#__PURE__*/React.forwardRef(function (_a, outerRef) {
  var className = _a.className,
    inverted = _a.inverted,
    _a$dataTestid = _a['data-testid'],
    testId = _a$dataTestid === undefined ? 'counterchip' : _a$dataTestid,
    icon = _a.icon,
    _a$tooltip = _a.tooltip,
    tooltip = _a$tooltip === undefined ? false : _a$tooltip,
    tooltipProps = _a.tooltipProps,
    _a$showSuffix = _a.showSuffix,
    showSuffix = _a$showSuffix === undefined ? true : _a$showSuffix,
    label = _a.label,
    _a$counter = _a.counter,
    counter = _a$counter === undefined ? 0 : _a$counter,
    themeProps = _a.themeProps,
    hideCounter = _a.hideCounter,
    otherProps = __rest(_a, ["className", "inverted", 'data-testid', "icon", "tooltip", "tooltipProps", "showSuffix", "label", "counter", "themeProps", "hideCounter"]);
  var counterInString = getCounterString(counter, showSuffix, label);
  var ref = React.useRef(null);
  var _React$useState = React.useState(false),
    isOverflowing = _React$useState[0],
    setIsOverflowing = _React$useState[1];
  React.useEffect(function () {
    if (ref.current) {
      setIsOverflowing(ref.current.scrollWidth > ref.current.clientWidth);
    }
  }, [counter]);
  var showTooltip = tooltip || isOverflowing || counter > 10000;
  var tooltipContent = typeof tooltip === 'string' ? tooltip : counter.toLocaleString();
  return jsx(Tooltip, Object.assign({
    content: tooltipContent,
    disabled: !showTooltip
  }, tooltipProps, {
    children: jsxs("div", Object.assign({
      "data-testid": testId,
      ref: outerRef,
      className: classNames.apply(undefined, ['cogs-v10', 'cogs-counterchip'].concat(getThemeClassNames(inverted, themeProps), [className]))
    }, otherProps, {
      children: [showTooltip ? jsx(VisuallyHidden, {
        children: tooltipContent
      }) : null, icon && jsx(IconWrapper, {
        size: 12,
        className: "cogs-v10 cogs-counterchip--icon-container",
        children: icon
      }), !hideCounter && jsx(Body, {
        size: "x-small",
        strong: true,
        ref: ref,
        className: "cogs-v10 cogs-counterchip--text ",
        children: counterInString
      })]
    }))
  }));
});

export { CounterChip };
